$(() => {
  $(document).on('click', '.facetwp-page, .facetwp-radio', (e) => {
    const adminBarHeight =
      $('#wpadminbar').length > 0 ? $('#wpadminbar').height() : 0;
    const headerHeight = $('header').height() + adminBarHeight - 20;
    $('html, body').animate({
      scrollTop: $(e.currentTarget).closest('section').offset().top - headerHeight
    }, 500);
  });
});
